// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:18:22

export default {
  "id": "puzzle-blocks-fill-it-completely",
  "slug": "puzzle-blocks-fill-it-completely",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/115829e099c140a788170a3cfa08cbe6-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/115829e099c140a788170a3cfa08cbe6/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Puzzle Blocks: Fill It Completely",
      "description": "Discover the world of exciting puzzles!\n\nIn this game, you have to collect shapes by filling them with blocks of different sizes and configurations. Each task is a unique logical task that requires attention, patience and a strategic approach.\nVarious difficulty levels - from easy for beginners to difficult for real masters.\nOriginal shapes and blocks - each level is unique.\n",
      "instructions": "Select a level. Each level offers a shape that needs to be filled.\nMove blocks of different shapes and sizes using the mouse or touch screen.\nPlace the blocks inside the shape so that they fill it completely.\nIf a block does not fit, move it to the side and try another one.\nComplete the level by filling the shape without gaps!\n",
      "genres": [
        "Merge"
      ],
      "tags": [
        "block",
        "fill",
        "levels",
        "logic",
        "tetris"
      ]
    },
    "zh-CN": {
      "title": "拼图方块：填满它",
      "description": "探索令人兴奋的谜题世界！\n\n在这款游戏中，您需要通过填充不同大小和配置的方块来收集形状。每个任务都是一个独特的逻辑任务，需要注意力、耐心和战略性的方法。\n各种难度级别 - 从适合初学者的简单到适合真正大师的困难。\n原创形状和方块 - 每个关卡都是独一无二的。",
      "instructions": "选择一个关卡。每个关卡都提供了一个需要填满的形状。\n使用鼠标或触摸屏移动不同形状和大小的方块。\n将方块放入形状中，使其完全填满。\n如果方块无法放入，将其移动到旁边并尝试另一个方块。\n通过无空隙地填满形状来完成关卡！",
      "genres": [
        "合并"
      ],
      "tags": [
        "方块",
        "填充",
        "关卡",
        "逻辑",
        "俄罗斯方块"
      ]
    },
    "zh-TW": {
      "title": "拼圖方塊：填滿它",
      "description": "探索令人興奮的謎題世界！\n\n在這款遊戲中，您必須通過填充不同大小和配置的塊來收集形狀。每個任務都是一個獨特的邏輯任務，需要注意、耐心和戰略性的方法。\n各種難度等級 -從對新手來說的簡單到對真實大師來說的困難。\n獨特的形狀和塊 -每個關卡都是獨一無二的。",
      "instructions": "選擇一個等級。每個等級都提供一個需要填滿的形狀。\n使用滑鼠或觸控螢幕移動不同形狀和大小的塊。\n將塊放入形狀內，使其完全填滿。\n如果塊不適合，將其移到一旁並試另一個。\n完成等級，無間隙地填滿形狀！",
      "genres": [
        "合併"
      ],
      "tags": [
        "阻塞",
        "填滿",
        "關卡",
        "邏輯",
        "俄羅斯方塊"
      ]
    },
    "zh-HK": {
      "title": "謎題拼圖：填滿它",
      "description": "探索令人興奮的謎題世界！\n\n在這款遊戲中，您需要通過填滿不同大小和配置的塊來收集形狀。每個任務都是一個獨特的邏輯任務，需要專注、耐心和策略性的方法。\n各種難度等級 -從初学者的簡單到真正大師的困難。\n獨特形狀和塊 -每個等級都是獨一無二的。",
      "instructions": "選擇一個等級。每個等級都提供一個需要填滿的圖形。\n使用滑鼠或觸控螢幕移動不同形狀和大小的塊。\n將塊放入圖形內，使其完全填滿。\n如果塊不適合，將其移到一旁並試另一個。\n完成等級，填滿圖形不留下空隙！",
      "genres": [
        "合併"
      ],
      "tags": [
        "阻塞",
        "填滿",
        "關卡",
        "邏輯",
        "俄羅斯方塊"
      ]
    },
    "ja": {
      "title": "パズルブロック：完全に満たす",
      "description": "興味深いパズルの世界を発見してください！\n\nこのゲームでは、異なるサイズと形状のブロックで形状を埋めることで、形状を収集する必要があります。各タスクは、注意深さ、忍耐力、戦略的なアプローチが必要なユニークな論理タスクです。\n様々な難易度レベル - 初心者向けの簡単から、本格的なマスター向けの難しいまで。\nオリジナルの形状とブロック - 各レベルがユニークです。",
      "instructions": "レベルを選んでください。各レベルには、埋める必要がある形状があります。\nマウスやタッチスクリーンを使って、異なる形状とサイズのブロックを動かします。\nブロックをその形状の内に配置して、完全に埋めます。\nブロックが合わない場合は、その横に移動して別のブロックを試してください。\n形状に隙間なくブロックを埋めて、レベルをクリアしてください！",
      "genres": [
        "合体"
      ],
      "tags": [
        "ブロック",
        "フィル",
        "レベル",
        "ロジック",
        "テトリス"
      ]
    },
    "ko": {
      "title": "퍼즐 블록: 완전히 채우기",
      "description": "추적하고 흥미로운 퍼즐 세계를 탐험해보세요!\n\n이 게임에서는 다양한 크기와 구성의 블록을 채우며 모양을 수집해야 합니다. 각 테스크는 주의력, 인내심과 전략적 접근이 필요한 독특한 논리적 과제입니다.\n다양한 난이도 수준 - 초보자용 쉬운 난이도부터 진정한 마스터용 어려운 난이도까지.\n원래의 모양과 블록 - 각 레벨마다 독특합니다.",
      "instructions": "레벨을 선택하세요. 각 레벨은 채우는必要한 형상을 제공합니다.\n마우스나 터치스크린을 사용하여 다양한 형상과 크기의 블록을 이동하세요.\n블록을 형상 안에 맞추어 완전히 채우세요.\n불맞는 블록이 있으면, 그쪽으로 이동하여 다른 블록을 시도하세요.\n공간이 없이 형상을 채우고 레벨을 완료하세요!",
      "genres": [
        "데이터 통합"
      ],
      "tags": [
        "블록",
        "채우기",
        "레벨",
        "로직",
        "테트리스"
      ]
    },
    "fr": {
      "title": "Puzzle Blocks : Remplissez-le complètement",
      "description": "Découvrez le monde fascinant des puzzles étonnants !\n\nDans ce jeu, vous devez collecter des formes en les remplissant de blocs de différentes tailles et configurations. Chaque tâche est une mission logique unique qui nécessite de l'attention, de la patience et une approche stratégique.\nDifférents niveaux de difficulté - de facile pour les débutants à difficile pour les véritables maîtres.\nFormes et blocs originaux - chaque niveau est unique.",
      "instructions": "Sélectionnez un niveau. Chaque niveau propose une forme à remplir.\nDéplacez des blocs de différentes formes et tailles à l'aide de la souris ou de l'écran tactile.\nPlacer les blocs à l'intérieur de la forme pour qu'ils la remplissent complètement.\nSi un bloc ne s'adapte pas, déplacez-le de côté et essayez un autre.\nTerminez le niveau en remplissant la forme sans trous !",
      "genres": [
        "Fusionner"
      ],
      "tags": [
        "bloc",
        "remplir",
        "niveaux",
        "logique",
        "tétris"
      ]
    }
  }
};
